import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { SkapaTokens } from '@inter-ikea-guida/skapa';
const StyledContainer = styled.div `
  padding: ${SkapaTokens.space200};
`;
export const RecommendationsContainer = ({ children }) => {
    return (_jsx(_Fragment, { children: _jsx(StyledContainer, { children: children }) }));
};
//# sourceMappingURL=RecommendationsContainer.js.map